module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_07b.af2ec688.jpg";